import axios from 'axios/index'

import config from '../../config'
import action, { actionFailed } from '../../util/action'
import consts from '../../util/consts'
import createAsyncConst from '../../util/createAsyncConst'

export const REMOVE_USER = createAsyncConst('REMOVE_USER')
export const SUBMIT_USER = createAsyncConst('SUBMIT_USER')
export const FETCH_USER = createAsyncConst('FETCH_USER')
export const FETCH_PERMISSION_STRUCTURE = createAsyncConst(
  'FETCH_PERMISSION_STRUCTURE'
)
export const EDIT_USER = createAsyncConst('EDIT_USER')
export const SYNC_USER_PERMISSIONS = createAsyncConst('SYNC_USER_PERMISSIONS')
export const FETCH_NOTIFICATIONS = createAsyncConst('FETCH_NOTIFICATIONS')
export const MARK_ALL_AS_READ = createAsyncConst('MARK_ALL_AS_READ')
export const GET_REPORT = createAsyncConst('GET_REPORT')
export const CLEAR_EDITING_USER = 'CLEAR_EDITING_USER'

export function fetchUsers(filters = '') {
  return dispatch => {
    dispatch(action(FETCH_USER.ACTION))
    return axios
      .get(`${config.API_URL}/v2/users?${filters}`)
      .then(resp => {
        dispatch(action(FETCH_USER.SUCCESS, { data: resp.data }))
        return resp
      })
      .catch(e => dispatch(actionFailed(FETCH_USER, e)))
  }
}

export function clearEditingUser() {
  return action(CLEAR_EDITING_USER, null, false, false)
}

export function edit(id) {
  return dispatch => {
    dispatch(action(EDIT_USER.ACTION, { id }))
    return axios
      .get(`${config.API_URL}/users/${id}`)
      .then(resp => {
        return resp.data
      })
      .then(data => dispatch(action(EDIT_USER.SUCCESS, data)))
      .catch(e => dispatch(actionFailed(EDIT_USER, e)))
  }
}

export function post(values) {
  // O id nunca deve ir no cadastro: um editingUser residual no store faria o
  // POST cair na rota de item (/users/{id}), que só aceita GET/PUT/DELETE.
  const { id, ...rest } = values

  return submit(rest, 'post')
}

export function update(values) {
  return submit(values, 'put')
}

function submit(values, method) {
  const id = method !== 'post' && values.id ? `/${values.id}` : ''

  return dispatch => {
    dispatch(action(SUBMIT_USER.ACTION))
    return axios[method](`${config.API_URL}/users${id}`, values)
      .then(resp => resp.data)
      .then(data => {
        dispatch(action(SUBMIT_USER.SUCCESS, data))
        dispatch(fetchUsers())
        return data
      })
      .catch(e => dispatch(actionFailed(SUBMIT_USER, e)))
  }
}

export function remove(id) {
  return dispatch => {
    dispatch(action(REMOVE_USER.ACTION))
    return axios
      .delete(`${config.API_URL}/user/${id}`)
      .then(resp => resp.data)
      .then(data => {
        dispatch(action(REMOVE_USER.SUCCESS, data))
        dispatch(fetchUsers())
      })
      .catch(e => actionFailed(REMOVE_USER.FAILURE, e))
  }
}

export function fetchNotifications() {
  return dispatch => {
    dispatch(action(FETCH_NOTIFICATIONS.ACTION, {}, false, false))
    return axios
      .get(`${config.API_URL}/notifications`)
      .then(resp => resp.data)
      .then(data => {
        dispatch(action(FETCH_NOTIFICATIONS.SUCCESS, data, false, false))
        return data
      })
      .catch(e => actionFailed(FETCH_NOTIFICATIONS.FAILURE, e, false))
  }
}

export function markAllAsRead() {
  return dispatch => {
    dispatch(action(MARK_ALL_AS_READ.ACTION, {}, false, false))
    return axios
      .put(`${config.API_URL}/readAllNotifications`)
      .then(resp => resp.data)
      .then(data => {
        dispatch(action(MARK_ALL_AS_READ.SUCCESS, data, false, false))
        return data
      })
      .catch(e => actionFailed(MARK_ALL_AS_READ.FAILURE, e, false))
  }
}

export function makeReport(filters) {
  return dispatch => {
    return axios({
      url: `${config.API_URL}/user/fetch-users-report`,
      method: 'POST',
      responseType: 'blob',
      headers: { Accept: 'application/vnd.ms-excel' },
      params: {
        filters: JSON.stringify(filters),
      },
    })
      .then(resp => {
        const url = window.URL.createObjectURL(new Blob([resp.data]))
        const link = document.createElement('a')

        link.href = url
        link.setAttribute('download', 'users_report.xlsx')
        document.body.appendChild(link)
        link.click()
        return resp
      })
      .catch(e => dispatch(actionFailed(GET_REPORT, e)))
  }
}

export function fetchPermissionStructure() {
  return dispatch => {
    dispatch(action(FETCH_PERMISSION_STRUCTURE.ACTION))
    return axios
      .get(`${config.API_URL}/role-access/structure`)
      .then(resp => {
        dispatch(
          action(FETCH_PERMISSION_STRUCTURE.SUCCESS, { data: resp.data })
        )
        return resp
      })
      .catch(e => dispatch(actionFailed(FETCH_PERMISSION_STRUCTURE, e)))
  }
}

export function syncUserPermissions(
  userId,
  addedPermissions = [],
  removedPermissions = []
) {
  return dispatch => {
    dispatch(action(SYNC_USER_PERMISSIONS.ACTION))
    return axios
      .put(`${config.API_URL}/role-access/sync/${userId}`, {
        addedPermissions,
        removedPermissions,
      })
      .then(resp => {
        dispatch(action(SYNC_USER_PERMISSIONS.SUCCESS, resp?.data))
        dispatch(edit(userId))
        return true
      })
      .catch(e => {
        dispatch(actionFailed(SYNC_USER_PERMISSIONS, e))
        return false
      })
  }
}
